// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import { CustomAppState } from "@rc/App/Store/Reducers";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => {
    const pageType = getCurrentPage(state).type;

    return {
        isChangeCustomerPage: pageType === "ChangeCustomerPage",
        isAuthenticated: getSession(state).isAuthenticated && !getSession(state)?.isGuest,
        isCheckoutPages:
            pageType === "CheckoutShippingPage" ||
            pageType === "CheckoutReviewAndSubmitPage" ||
            pageType === "OrderConfirmationPage" ||
            pageType === "RfqRequestQuotePage" ||
            pageType === "RfqConfirmationPage",
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps>;

export interface FooterStyles {
    page?: MobiusPageProps;
    joinTodaySection?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    page: {
        css: css`
            background-color: ${getColor("common.ui6")};

            ${({ isChangeCustomerPage }: any) => {
                if (isChangeCustomerPage) {
                    return `
                        &&& {
                            visibility: hidden;
                            height: 0;
                            max-height: 0;
                            pointer-events: none;
                            display: none;
                        }
                    `;
                }
                return `

                `;
            }}
        `,
    },
    joinTodaySection: {
        css: css`
            margin-bottom: 15px;
        `,
    },
};
const styles = footerStyles;

const Footer = ({ id, isChangeCustomerPage, isAuthenticated, isCheckoutPages }: Props) => (
    <Page as="footer" fullWidth={[true, true, true, true, true]} isFooter={true} {...({ isChangeCustomerPage } as any)}>
        {isAuthenticated && !isCheckoutPages && (
            <Page {...styles.joinTodaySection}>
                <Zone contentId={id} zoneName="Content0" />
            </Page>
        )}
        <Page {...styles.page} fullWidth={[true, true, true, true, true]}>
            <Page>
                <Zone contentId={id} zoneName="Content" />
            </Page>
        </Page>
        <CookiePrivacyPolicyPopup />          
    </Page>
);

const pageModule: PageModule = {
    component: connect(mapStateToProps, null)(Footer),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
